import http from "../httpService";
import {getBaseUrl} from "../../config";


export const getServicePayments = (paginate) => {
  if (!paginate) {
    return http.get(
      `${getBaseUrl()}/service_settlement_milestone`
    );
  }
  return http.get(
    `${getBaseUrl()}/service_settlement_milestone?${paginate}`
  );
};

export const updateServicePayment = data => {
  return http.put(
    `${getBaseUrl()}/service_settlement_milestone/${data.id}`,
  );
};


export const updateCancelServicePayment = data => {
  return http.put(
    `${getBaseUrl()}/cancel_service_settlement_milestone/${data.id}`,
  );
};
